import { compose, withProps } from "recompose";
import * as hoc from "modules/user/auth/hoc";
import { isInsider } from "modules/user/auth/model";
import * as selectors from "modules/referral/selectors";
import * as api from "modules/referral/api";
import View from "./View";

export default compose(
  hoc.authorized(isInsider),
  withProps({
    submitApiSelector: selectors.sendInsiderInvitationApi,
    submitReferralApi: api.sendInsiderInvitation,
    mixpanelEvent: "insiderInvitationSent",
    title: "Invite other insiders to join The Lobby"
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Insider/Referral/Provider.js